import { render, staticRenderFns } from "./SiChartLine.vue?vue&type=template&id=2b65b16f&scoped=true&lang=html&"
import script from "./SiChartLine.vue?vue&type=script&lang=js&"
export * from "./SiChartLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65b16f",
  null
  
)

export default component.exports